import { URLS } from '@/config'

export const GATEWAY_BASE_URL = `https://gateway${URLS.URL_ENV_CODE}.farmapremium.es/`
export const APPS_BASE = `https://apps${URLS.URL_ENV_CODE}.farmapremium.es`
export const APPS_DASHBOARD = `${APPS_BASE}/dashboard`
export const APPS_LOGIN_URL = `${APPS_BASE}/login`
export const APPS_LOGOUT_URL = `${APPS_BASE}/logout`
export const APPS_CREATE_CARD_URL = `${APPS_BASE}/contents/appmobiles/create`
export const APPS_EDIT_CARD_URL = `${APPS_BASE}/contents/appmobiles/edit`
export const APPS_EDIT_PRODUCT_URL = `${APPS_BASE}/office/products/edit`
export const APPS_DASHBOARDS_URL = `${APPS_BASE}/dashboard`
export const OAUTH_BASE_URL = `https://accountsbackend${URLS.URL_ENV_CODE}.farmapremium.es`
export const ROOT_SITE = `https://${URLS.URL_ENV_CODE_ROOT_DOMAIN}farmapremium.es/`
export const ROOT_SITE_LOGOUT = `${ROOT_SITE}logout`
export const ROOT_SITE_LOGIN = `${ROOT_SITE}login`
export const TOKEN_URL = `${GATEWAY_BASE_URL}auth/user/v1/token`
export const USER_INFO_URL = `${GATEWAY_BASE_URL}auth/user/v1/info`
export const CRM_REFRESH_TOKEN_URL = `${APPS_BASE}/refresh-token`
export const CUSTOMER_REFRESH_TOKEN_URL = `${ROOT_SITE}refresh-token`
export const STORAGE_IMAGES = 'https://public-storage.farmapremium.es/images/'
export const PUBLIC_STORAGE = 'https://public-storage.farmapremium.es'
export const FRONTEND_ASSETS = `${PUBLIC_STORAGE}/applications/frontend-assets`
export const FP_APPLICATIONS = `${PUBLIC_STORAGE}/applications`
export const FARMACLOUD = `https://${URLS.FARMACLOUD_URL_ENV_CODE}.farmacloud.io`
export const GATEWAY_FARMACLOUD = `https://gateway${URLS.URL_ENV_CODE}.farmacloud.io`
export const COMMUNICATIONS_CONFIG_URL = `https://micro-frontends.nexterafarma.com/shell-config/communications${URLS.URL_ENV_CODE}-config.json`
export const FARMAPOLIS_URL = `https://hub${URLS.URL_ENV_CODE}.farmapolis.es/repofarma/`
